<template>
  <div class="root-warp">
    <div class="body-box">
      <div class="header">
        <div class="school-title">{{scoolName}}</div>
        <div class="datetime">{{currentTime.date}}&nbsp; &nbsp; {{currentTime.time}}&nbsp; &nbsp;{{currentTime.week}}</div>
        <div class="notice">
          <div class="laba-img"></div>
          <div class="text">{{noticeText}}</div>
        </div>
        <div class="status">
        <div :class="['footer-item', item.class]" v-for="item of footerArr" :key="item.text">
          <span class="block"></span>
          <span style="margin-left:5px">{{item.text}}</span>
        </div>
      </div>

      </div>

      <div :class="['weifx','item-box']">
        <div class="title">
          未放学
          <template v-if="isShowCaret[0]">
            <i v-if="isSpread0" class="el-icon-caret-top" @click="fold(0)"></i>
            <i v-else class="el-icon-caret-bottom" @click="spread(0)"></i>
          </template>
        </div>
        <div class="content" id="content0">
          <span class="item" v-for="item of weifxArr" :key="item.id">{{item.className}}</span>
        </div>
      </div>
      <div :class="['fxzhong','item-box']">
        <div class="title">
          放学中
          <template v-if="isShowCaret[1]">
            <i v-if="isSpread1" class="el-icon-caret-top" @click="fold(1)"></i>
            <i v-else class="el-icon-caret-bottom" @click="spread(1)"></i>
          </template>
        </div>
        <div class="content" id="content1">
          <span class="item" v-for="item of fxzhongArr" :key="item.id">{{item.className}}</span>
        </div>
      </div>
      <div :class="['yifx','item-box']">
        <div class="title">
          已放学
          <template v-if="isShowCaret[2]">
            <i v-if="isSpread2" class="el-icon-caret-top" @click="fold(2)"></i>
            <i v-else class="el-icon-caret-bottom" @click="spread(2)"></i>
          </template>
        </div>
        <div class="content" id="content2">
          <span class="item" v-for="item of yifxArr" :key="item.id">{{item.className}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myMixin from "./mixin/index.js";

export default {
  mixins: [myMixin],
  mounted(){
    function fontSize(){
        var deviceWidth=document.documentElement.clientWidth>768?768:document.documentElement.clientWidth;
        document.documentElement.style.fontSize=(deviceWidth/25)+"px";
        console.log((deviceWidth/25)+"px");
    }
    fontSize();
    window.onresize=fontSize;
  }
};


</script>

<style lang='scss' scoped>
@mixin hvCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.root-warp {
  width: 100vw;
  padding: 0.3rem;

  .body-box {
    width: 100%;
    min-height: 98.5vh; // 控制整体的最小高度
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header {
      height: auto;
      background: #1d9ed7;
      border-radius: 0.5rem;

      .school-title {
        font-size: 2rem;
        height: auto;
        color: white;
        @include hvCenter;
        text-shadow: 0.35rem 0.35rem 0.4rem #070707;
        padding: 5px 10px;
      }
      .datetime {
        height: 15%;
        font-size: 1.2rem;
        color: white;
        @include hvCenter;
      }
      .notice {
        height: 50%;
        color: #ffff00;
        font-size: 1.5rem;
        @include hvCenter;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .laba-img {
          width: 5rem;
          height: 4rem;
          background: url("~@/assets/images/laba.png");
          background-size: 100% 100%;
          border-radius: 0.4rem;
        }
        .text {
          width: 70%;
        }
      }

      .status {
        height: 4rem;
        background: black;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 1.6rem;
        margin-top: 0.6rem;
        border-radius: 0.5rem;

        .footer-item {
          width: 30%;
          display: flex;
          justify-content: center;
          align-items: center;

          .block {
            display: inline-block;
            width: 2rem;
            height: 2rem;
            border-radius: 0.3rem;
          }
        }
        .redC {
          color: #ff0000;
          .block {
            background: #ff0000;
          }
        }
        .purpleC {
          color: #c6f;
          .block {
            background: #c6f;
          }
        }
        .greenC {
          color: #3f3;
          .block {
            background: #3f3;
          }
        }
      }


    }


    // 下面三个放学状态盒
    .item-box {
      min-height: 8.5rem;
      border: 1px solid black;
      margin-top: 0.6rem;
      border-radius: 0.5rem;
      transition: all .5s;
      height: 8.5rem;
      overflow: hidden;
      .title{
        font-size: 2.3rem;
        height: 2.6rem;
        line-height: 2.6rem;
        padding-left: 0.3rem;
        text-shadow: 0.2rem 0.2rem 0.3rem #070707;
        i{
          margin-left: 13rem;
        }
      }
      .content{

        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-flow: row wrap;
        font-size: 1.6rem;
        .item{
          width: auto;
          height: 3.1rem;
          @include hvCenter();
          padding:1rem;
        }
      }
    }
    .partShow{
      height: 8.5rem;
      overflow: hidden;
    }

    .weifx {
      color: #ff0000;
      border: 1px solid #ff0000;
    }
    .fxzhong {
      color: #c6f;
      border: 1px solid #c6f;
    }
    .yifx {
      color: #3f3;
      border: 1px solid #3f3;
    }
  }
}
</style>
